import { useMySubscription } from './useSubscription';

/**
 * Installment payments (bKash / bank slip) unlock only once the booking is verified at the office.
 * The backend refuses earlier ones with 422 BOOKING_NOT_VERIFIED; this keeps the options from being offered.
 * Locks only on an explicit `bookingVerified === false`, so loading, no-subscription and agent views stay unlocked.
 */
export function usePaymentLock() {
  const sub = useMySubscription();
  return { locked: sub.data?.bookingVerified === false, loading: sub.isLoading };
}
